// Janela de resposta do Instagram Direct e do Messenger (#344): a Meta só aceita a resposta nas
// 24 horas seguintes à última mensagem do contato. A regra que vale é a do backend (409 no
// envio); aqui só avisamos antes, para o operador não escrever uma resposta que não sai.

export const DM_CHANNELS = ['instagram', 'messenger']
export const DM_WINDOW_MS = 24 * 60 * 60 * 1000

// Conversa que responde pela Graph API da Meta (as criadas à mão, sem provider, não contam).
export const isDmConversation = (conv) =>
  !!conv && conv.wa_provider === 'meta' && DM_CHANNELS.includes(conv.channel)

const ms = (iso) => {
  const t = iso ? new Date(iso).getTime() : NaN
  return Number.isNaN(t) ? null : t
}

// Quando a janela fecha (ms) ou null se o contato ainda não escreveu. Usa a data do servidor
// (`dm_window_expires_at`, que olha o histórico inteiro) e a das mensagens carregadas, e fica com a
// mais nova: a mensagem recém-chegada abre a janela antes da próxima consulta ao servidor.
export function dmWindowExpiry(messages = [], serverExpiresAt = null) {
  let latest = null
  for (const m of messages || []) {
    if (m.sender_type !== 'contato') continue
    const t = ms(m.created_at)
    if (t !== null && (latest === null || t > latest)) latest = t
  }
  const fromMessages = latest === null ? null : latest + DM_WINDOW_MS
  const fromServer = ms(serverExpiresAt)
  if (fromMessages === null) return fromServer
  if (fromServer === null) return fromMessages
  return Math.max(fromMessages, fromServer)
}

export const isDmWindowOpen = (expiresAt, now = Date.now()) => expiresAt !== null && expiresAt > now

// "5 h 20 min", "40 min" ou "menos de 1 min".
export function formatWindowLeft(expiresAt, now = Date.now()) {
  const left = (expiresAt ?? 0) - now
  if (left <= 0) return '0 min'
  const minutes = Math.floor(left / 60000)
  if (minutes < 1) return 'menos de 1 min'
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m} min`
  return m === 0 ? `${h} h` : `${h} h ${m} min`
}
